/**
 * Possible status for Surveys
 */
export enum SurveyStatusEnum {
  NEW = 'NEW',
  INPROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
}
